export const CheckSquareIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3021_16829)">
        <path
          d="M13.9995 0.999023C14.2647 0.999023 14.5191 1.10438 14.7066 1.29192C14.8942 1.47945 14.9995 1.73381 14.9995 1.99902V13.999C14.9995 14.2642 14.8942 14.5186 14.7066 14.7061C14.5191 14.8937 14.2647 14.999 13.9995 14.999H1.99951C1.7343 14.999 1.47994 14.8937 1.2924 14.7061C1.10487 14.5186 0.999512 14.2642 0.999512 13.999V1.99902C0.999512 1.73381 1.10487 1.47945 1.2924 1.29192C1.47994 1.10438 1.7343 0.999023 1.99951 0.999023H13.9995ZM1.99951 -0.000976562C1.46908 -0.000976562 0.960371 0.209737 0.585298 0.58481C0.210225 0.959883 -0.000488281 1.46859 -0.000488281 1.99902V13.999C-0.000488281 14.5295 0.210225 15.0382 0.585298 15.4132C0.960371 15.7883 1.46908 15.999 1.99951 15.999H13.9995C14.5299 15.999 15.0387 15.7883 15.4137 15.4132C15.7888 15.0382 15.9995 14.5295 15.9995 13.999V1.99902C15.9995 1.46859 15.7888 0.959883 15.4137 0.58481C15.0387 0.209737 14.5299 -0.000976562 13.9995 -0.000976562H1.99951Z"
          fill="#198754"
        />
        <path
          d="M10.9695 4.96902C11.1095 4.8303 11.2984 4.75222 11.4954 4.75168C11.6925 4.75113 11.8819 4.82816 12.0226 4.96612C12.1633 5.10407 12.244 5.29186 12.2474 5.48889C12.2508 5.68592 12.1764 5.87635 12.0405 6.01902L8.04851 11.009C7.9799 11.0829 7.8971 11.1422 7.80504 11.1834C7.71299 11.2246 7.61358 11.2467 7.51276 11.2486C7.41194 11.2505 7.31178 11.232 7.21827 11.1943C7.12475 11.1565 7.03981 11.1003 6.96851 11.029L4.32351 8.38302C4.24983 8.31436 4.19072 8.23156 4.14973 8.13956C4.10874 8.04756 4.0867 7.94825 4.08492 7.84755C4.08314 7.74684 4.10167 7.64681 4.13939 7.55343C4.17711 7.46004 4.23325 7.3752 4.30447 7.30399C4.37569 7.23277 4.46053 7.17662 4.55391 7.1389C4.6473 7.10118 4.74733 7.08265 4.84803 7.08443C4.94874 7.08621 5.04805 7.10825 5.14005 7.14924C5.23205 7.19023 5.31485 7.24934 5.38351 7.32302L7.47751 9.41602L10.9505 4.99102C10.9567 4.98328 10.9624 4.97593 10.9695 4.96902Z"
          fill="#198754"
        />
      </g>
      <defs>
        <clipPath id="clip0_3021_16829">
          <rect
            width="16"
            height="16"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
